import { LoginUsersService } from "./../../Services/login-users.service";
import { CanActivate, Router } from "@angular/router";
import { Injectable, Inject, PLATFORM_ID } from "@angular/core";
import { isPlatformServer } from "@angular/common";
import { EmbryoService } from "../../Services/Embryo.service";
@Injectable()
export class AuthGuard implements CanActivate {
    lang: any;
    constructor(
        public embryoService: EmbryoService,
        private router: Router,
        private auth: LoginUsersService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.embryoService.emitLang.subscribe((lang: any) => {
            this.lang = lang;
        });
    }

    async canActivate() {
        if (isPlatformServer(this.platformId)) {
            return true;
        }

        if (this.auth.isAuthenticated()) {
            return true;
        }
        var currentUrl = window.location.href.replace(
            window.location.origin,
            ""
        );

        this.router.navigate(["/" + this.lang + "/session/signin"], {
            queryParams: { returnUrl: currentUrl },
        });
        return false;
    }
}
